export default __webpack_public_path__ + "static/DAWG-f47ce8127881d737fd65cdac4eb74a7f.jpg";